import { toGlobalId } from '@shared/utils/global-id';

export const CAMPAIGN_VALIDATION_ERROR_CODE =
  'invalid_recipient_template_values';

export const getCampaignRecipientProfilePath = (userId: string): string =>
  `/v1/users/${toGlobalId('User', userId)}/overview`;

export type CampaignValidationError = {
  code: typeof CAMPAIGN_VALIDATION_ERROR_CODE;
  message: string;
  invalidFields: string[];
  invalidRecipients: Array<{
    userId?: string;
    email: string;
    name?: string;
    missingFields: string[];
  }>;
};

export const isCampaignValidationError = (
  value: unknown,
): value is CampaignValidationError => {
  if (value == null || typeof value !== 'object') {
    return false;
  }

  const candidate = value as Partial<CampaignValidationError>;
  return (
    candidate.code === CAMPAIGN_VALIDATION_ERROR_CODE &&
    typeof candidate.message === 'string' &&
    Array.isArray(candidate.invalidFields) &&
    Array.isArray(candidate.invalidRecipients)
  );
};
